import {WhiteBgButton} from '@packages/ui';
import Image from 'next/image';
import {useRouter} from 'next/router';
import type {FC} from 'react';
import {MdBusiness} from 'react-icons/md';
import {COLOR_WHITE} from '../../../../../config/constants/colorCodes';
import {CommonLink} from '../../../../../shared/components/CommonLink';

type Props = {
  companyId: number;
  companyName: string;
  logoImageUrl: string;
  industry: string;
  isArchivesPage?: boolean;
  isPC: boolean;
};

export const BottomCompanyInfo: FC<Props> = ({
  companyId,
  companyName,
  logoImageUrl,
  industry,
  isArchivesPage = false,
  isPC,
}) => {
  const router = useRouter();
  const COMPANY_PAGE_URL = `/company/${companyId}`;

  return (
    <div className="w-full">
      <div className="flex items-center mt-16 w-full">
        <CommonLink
          href={COMPANY_PAGE_URL}
          className="pc:hover:cursor-pointer pc:hover:opacity-80"
        >
          {!isArchivesPage && logoImageUrl ? (
            <div className="w-[60px] h-[50px] flex relative items-center justify-center">
              <Image
                src={logoImageUrl}
                alt={companyName}
                fill
                className="object-contain relative"
              />
            </div>
          ) : (
            <div className="bg-category-5 w-[60px] h-[60px] flex flex-col justify-center items-center">
              <MdBusiness size={36} color={COLOR_WHITE} />
              <p className="text-white text-xs leading">企業情報</p>
            </div>
          )}
        </CommonLink>
        <CommonLink
          href={COMPANY_PAGE_URL}
          className="ml-8 pc:hover:cursor-pointer pc:hover:opacity-80"
        >
          <h1 className="text-md font-bold text-black-1">
            「{companyName}」の企業情報を見る
          </h1>
          <p className="text-sm text-black-2">{industry}</p>
        </CommonLink>
      </div>
      {!isPC && (
        <div className="mt-8 w-full">
          <WhiteBgButton
            className="w-full px-12"
            label={`「${companyName}」の企業情報を見る`}
            onClick={async () => router.push(COMPANY_PAGE_URL)}
            isLarge={false}
            isPrimary={false}
          />
        </div>
      )}
    </div>
  );
};
